<div
  class="combined-calendar flex flex-col basis-full flex-grow app-full-height"
>
  <mat-drawer-container class="flex flex-grow basis-full">
    <mat-drawer #drawer class="app-bg">
      <app-calendar-filter
        (closePressed)="drawer.close()"
      ></app-calendar-filter>
    </mat-drawer>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex class="m-4">
      <div class="flex flex-row justify-start items-center gap-x-6">
        <app-quick-filter></app-quick-filter>
        <button mat-flat-button (click)="drawer.open()" data-cy="open-filter">
          More Filters
        </button>
      </div>
      <div>
        <button mat-icon-button (click)="updateCalendarDate(-1)">
          <mat-icon>navigate_before</mat-icon>
        </button>
        <button (click)="updateCalendarDate(0)" mat-button>Today</button>
        <button (click)="updateCalendarDate(1)" mat-icon-button>
          <mat-icon>navigate_next</mat-icon>
        </button>
      </div>
    </div>

    <div class="mx-4">
      <mwl-calendar-week-view
        data-cy="calendar"
        [viewDate]="calendarDate$ | async"
        [events]="events$ | async"
        [dayEndHour]="18"
        [dayStartHour]="7"
        [weekStartsOn]="1"
        (eventClicked)="clicked($event)"
      >
      </mwl-calendar-week-view>
    </div>
  </mat-drawer-container>
</div>
